import {combineReducers} from 'redux';
import {uiReducer} from './ui/uiReducer';
import {configReducer} from './config/configReducer';
import {geolocationReducer} from './geolocation/geolocationReducer';
import {locationsHistoryReducer} from './locationsHistory/locationsHistoryReducer';
import {forecastReducer} from './forecast/forecastReducer';
import {mapsReducer} from './maps/mapsReducer';

export const rootReducer = combineReducers({
	ui: uiReducer,
	config: configReducer,
	geolocation: geolocationReducer,
	locationsHistory: locationsHistoryReducer,
	weather: forecastReducer,
	maps: mapsReducer,
});
